export default __webpack_public_path__ + "static/media/Wealth-Gain-Plus-Brochure.66d114f5.pdf";